<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm">
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body">  
                                    <div class="row">
                                        <div class="col-md-8"> 
                                            <div class=" d-flex align-items-center pl-3">
                                                <img alt="Logo" src="../../assets/img/fee.png" class="mh-45px pb-2">
                                               <p class="mb-1">
                                                    <span class="main-content-label"><b>Fees Head</b></span><br>
                                                    <span class="text-muted card-sub-title mb-0">List Of Fees Head</span>
                                                </p>
                                              </div> 
                                        </div>
                                        
                                        <div class="col-md-3" [formGroup]="FeeTemplateSearch">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>Search
                                                </mat-label> <input class="color" matInput placeholder="Search"
                                                    (keyup)="keypress()" formControlName="SearchString">
                                                <mat-icon matSuffix>search</mat-icon>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-1 prpl">
                                            <button id="addBtn" type="button"
                                                class="btn btn-primary btn-icon-text  mt-1"
                                                (click)="addnewrecord()">
                                                <span style="display: flex; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/plus.gif"
                                                        style="margin-right: 5px;">
                                                    New
                                                </span>
                                            </button>
                                        </div>
                                    </div> 
                                    <hr>
                                    <div class="table-responsive table-container">
                                        <table appShortTable id="datatable"
                                            class="table table-bordered text-nowrap text-left">
                                            <thead>
                                                <tr>
                                                    <th class="f600">
                                                        Head Code
                                                    </th>
                                                    <th class="f600">
                                                        Head
                                                    </th>
                                                    <th class="f600">
                                                        Clg/Uni
                                                    </th>
                                                    <th width="10%" class="f600 text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody id="table_data">
                                                <tr *ngFor="let item of FeeHeadList">
                                                    <td> {{item.HeadCode}}</td>
                                                    <td>{{item.Head}} </td>
                                                    <td> {{item.Uni_Colg}}</td>
                                                    <td class="text-center"> <a class="floating mr-2 pr-3" title="Edit"
                                                        (click)="editData(item)"> <i 
                                                            class="fa fa-edit "></i> </a> <a class=" ml-2 floating"
                                                        title="Delete" (click)="deleteData(item)"> <i
                                                            class="fas fa-trash"></i> </a> </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                                    (page)="onPageChange($event)"></mat-paginator>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </form>
</body>